import { GET_LIST_TIM_KERJA_OPERATOR, GET_LIST_ANGGOTA_TIM_KERJA, GET_DETAIl_TIM_KERJA, GET_LIST_TIM_KERJA_ADMINISTRATOR, GET_OPTION_TIM_KERJA_CATEGORY, GET_PIMPINAN_TIM_KERJA } from "shared/constants/ActionTypes";

const INIT_STATE = {
    timKerja: {
        list: {
            result: [],
        },
        listAdmin: {
            result: [],
        },
        detail: {
            result: null
        },
        listAnggota: {
            results: []
        },
        categoryOption: {
            choice: [],
        },
        pimpinan: {
            result: null
        }
    }
};

const manajemenReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_TIM_KERJA_OPERATOR: {
            return {
                ...state,
                timKerja: {
                    ...state.timKerja,
                    list: {
                        result: action.payload?.result || action.payload?.results
                    }

                }
            }
        }
        case GET_LIST_TIM_KERJA_ADMINISTRATOR: {
            return {
                ...state,
                timKerja: {
                    ...state.timKerja,
                    listAdmin: {
                        result: action.payload?.result || action.payload?.results
                    }

                }
            }
        }
        case GET_DETAIl_TIM_KERJA: {
            return {
                ...state,
                timKerja: {
                    ...state.timKerja,
                    detail: action.payload
                }
            }
        }
        case GET_LIST_ANGGOTA_TIM_KERJA: {
            return {
                ...state,
                timKerja: {
                    ...state.timKerja,
                    listAnggota: action.payload
                }
            }
        }
        case GET_OPTION_TIM_KERJA_CATEGORY: {
            const tmpChoice = action.payload?.result?.map((item) => ({ id: item.key, label: item.name }))
            return {
                ...state,
                timKerja: {
                    ...state.timKerja,
                    categoryOption: {
                        choice: tmpChoice
                    }
                }
            }
        }
        case GET_PIMPINAN_TIM_KERJA: {
            return {
                ...state,
                timKerja: {
                    ...state.timKerja,
                    pimpinan: action.payload
                }
            }
        }
        default:
            return state;
    }
};
export default manajemenReducer;
